import React, {
  useCallback,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from 'react'
import { Tooltip } from 'react-tippy'
import styled from 'styled-components'

import { LocationDisableText } from '../selector/styled'

const TextWrapper = styled.div((props) => ({
  width: props.width ? `${props.width}px` : '100%',
  display: 'flow-root',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}))

const TextOverflow = ({
  text = '',
  tag: Tag = 'span',
  popupText = '',
  position = 'bottom',
  color = 'inherit',
  maxWidth = null,
  display = 'inline-block',
  width = null,
}) => {
  const [widthState, setWidthState] = useState(width)
  const [open, setOpen] = useState(false)
  const textRef = useRef()
  const wrapRef = useRef()

  const onMouseOver = useCallback(() => {
    if (
      (textRef.current &&
        widthState &&
        textRef.current.offsetWidth > widthState) ||
      (textRef.current &&
        wrapRef.current &&
        textRef.current.offsetWidth > wrapRef.current?.offsetWidth)
    )
      setOpen(true)
  }, [widthState])

  useLayoutEffect(() => {
    if (!width && maxWidth < wrapRef.current?.offsetWidth)
      setWidthState(maxWidth)
  }, [maxWidth, width])

  const tagText = useMemo(() => {
    return (
      <TextWrapper width={width}>
        <Tag
          ref={textRef}
          onMouseOver={onMouseOver}
          onMouseLeave={() => setOpen(false)}
          style={{ width: 'max-content', color }}
        >
          {text}
        </Tag>
      </TextWrapper>
    )
  }, [width, onMouseOver, color, text])

  return (
    <div ref={wrapRef} style={{ width: '100%' }}>
      <Tooltip
        disabled={!open}
        title={popupText || text}
        position={position}
        arrow
        style={{
          display,
        }}
        popperOptions={{
          modifiers: {
            preventOverflow: {
              enabled: true,
            },
            hide: {
              enabled: true,
            },
            addZIndex: {
              enabled: true,
              order: 810,
              fn: (data) => ({
                ...data,
                styles: {
                  ...data.styles,
                  zIndex: 100001,
                },
              }),
            },
          },
        }}
        html={<LocationDisableText text={`<b>${text}</b>`} />}
      >
        {tagText}
      </Tooltip>
    </div>
  )
}

export default TextOverflow
